/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ESTATE_FILTER_LABEL: Record<string, string> = {
  waste: "Estate Records with Savings Suggestions",
  unassigned: "Unallocated Estate Records",
  external: "Estate Records from External Integrations",
  enrichment: "Estate Records with Enrichments",
  co2eWaste: "Estate Records with Carbon Emissions Savings",
};

/* This constant specifies earliest selectable date in unassigned estate records datepicker. We don't have any data before this time period so there is no point in filtering earlier. */
export const MIN_FILTER_DATE = "2022-03-02" as const;

export enum CostSplittingRule {
  singleEnv = "SINGLE_ENVIRONMENT",
  multipleEnv = "MULTIPLE_ENVIRONMENTS",
}

export const costSplittingRules = [
  {
    name: "Single",
    labelText: "Single Environment",
    value: CostSplittingRule.singleEnv,
  },
  {
    name: "Multiple",
    labelText: "Multiple Environments",
    value: CostSplittingRule.multipleEnv,
  },
];

export const DEBOUNCE_TIMEOUT_MS = 500;
